module.exports = __webpack_public_path__ + "img/icon_ks+ksjhkslt.7f4aaff7.png";